import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentUser } from '../states/modules/users';

const useFetchCurrentUser = () => {
	const dispatch = useDispatch();

	const {
		error = null,
		loading = false,
		data: currentUser,
		fetched = false,
	} = useSelector(({ users }) => users?.currentUser || {});

	useEffect(() => {
		if (!fetched) {
			dispatch(getCurrentUser());
		}
	}, [dispatch, fetched]);

	return { currentUser, loading, error };
};

export default useFetchCurrentUser;
